import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8l6 6H6l6-6z" }));
export default createSvgIcon(iconPath, "ArrowFillUp");
//# sourceMappingURL=ArrowFillUpIcon.js.map